import Image from "next/image";
import styles from "./ContentAuthor.module.scss";

type Author = keyof typeof authors;

const authors = {
  daniel: {
    name: "Daniel Wyrzykowski",
    image: "daniel-w.jpeg",
    description: "Founder @ Devs for Good",
  },
  kinga: {
    name: "Kinga Gomulka",
    image: "kinga-g.jpeg",
    description: "Content Creator @ Devs for Good",
  },
  luiza: {
    name: "Luiza Pietraszko",
    image: "luiza-p.jpeg",
    description: "Content Creator @ Devs for Good",
  },
};

export const ContentAuthor = ({ who }: { who: Author | Author[] }) => {
  if (Array.isArray(who)) {
    return (
      <div className={styles.authors}>
        {who.map((author) => (
          <ContentAuthor who={author} key={author} />
        ))}
      </div>
    );
  }

  const { name, image, description } = authors[who];
  return (
    <div className={styles.author}>
      <Image
        className={styles.authorImage}
        src={`/authors/${image}`}
        alt={name}
        width={50}
        height={50}
      />
      <div>
        <div className={styles.authorName}>{name}</div>
        <div className={styles.authorDescription}>{description}</div>
      </div>
    </div>
  );
};
